module.exports = __webpack_public_path__ + "img/IMG_9321_L_Black.e1610790.jpg";